module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Here's How You Can Help!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": "/#donate"
    }
  }, [_vm._v("Donate Now")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta"
  }, [_c('div', {
    staticClass: "module"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_DonateHand.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Your Donation")])]), _vm._v(" "), _c('div', {
    staticClass: "module"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_Backpack.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Gives backpacks with school supplies & uniforms")])]), _vm._v(" "), _c('div', {
    staticClass: "module"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_GraduationCap.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Supports education for kids in developing countries")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11bf14d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/HowToHelp.vue
// module id = 305
// module chunks = 1